import { useEffect } from 'react';

function CounterSection({ data }) {

    // Ensure sortedContent is always defined so hooks run unconditionally
    const sortedContent = (data && data.counter_content && Array.isArray(data.counter_content))
        ? [...data.counter_content].sort((a, b) => a.counter_grid_order_number - b.counter_grid_order_number)
        : [];

    // Counter animation effect (hook runs on every render but exits early if no items)
    useEffect(() => {
        if (sortedContent.length === 0) return;

        const animateCounters = () => {
            const counters = document.querySelectorAll('.counter');
            counters.forEach(counter => {
                const target = parseInt(counter.getAttribute('data-target'), 10) || 0;
                const duration = 2000; // 2 seconds
                const increment = target / (duration / 16); // ~60fps
                let current = 0;

                const updateCounter = () => {
                    if (current < target) {
                        current += increment;
                        counter.textContent = Math.ceil(current);
                        requestAnimationFrame(updateCounter);
                    } else {
                        counter.textContent = target;
                    }
                };

                updateCounter();
            });
        };

        animateCounters();
    }, [sortedContent.length]); // Dependency on length instead of array reference

    // If no valid data, show loader
    if (!data || !data.counter_content || !Array.isArray(data.counter_content)) {
        return (
            <div className='loader'>
                <img
                    src="assets/img/LoaderSky47.gif"
                    alt='Loading counters'
                    width="100"
                    height="100"
                    loading="lazy"
                />
            </div>
        );
    }

    return (
        <div className="counters_section">
            <div className="card-wrapper">
                {/* FIX: Remove extra div wrapper and use stable unique keys */}
                {sortedContent.map((item, index) => {
                    // Create stable key from counter data
                    const stableKey = `counter-${item.counter_grid_order_number}-${item.counter_text?.replace(/\s+/g, '-') || index}`;
                    const isLastItem = index === sortedContent.length - 1;
                    const isFirstItem = index === 0;

                    return (
                        <div key={stableKey} className='d-flex card-separator-wrapper'>
                             {!isFirstItem && !isLastItem && <div className="separator"></div>}
                            <div className="card">
                                <div className="card-content">
                                    <img
                                        src={item.counter_icon_url}
                                        className="counter-icon"
                                        alt={`${item.counter_text} icon`}
                                        width="60"
                                        height="60"
                                        loading="lazy"
                                    />
                                    <h3>
                                        <span className="counter" data-target={item.counter_number}>
                                            0
                                        </span>
                                        {item.counter_text}
                                    </h3>
                                </div>
                                <p>{item.counter_paragraph}</p>
                            </div>
                            {/* FIX: Conditional rendering should always return same node structure */}
                            {!isLastItem && !isFirstItem && <div className="separator"></div>}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default CounterSection;
